module.exports = __webpack_public_path__ + "sa.eba985d64d7bc395ea0b.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/sa.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/sa.svg
// module chunks = styles